import { gql } from '@apollo/client'

export const GET_ASSET_SHARE_QUERY = gql`
  query GetAsset($assetId: ID!) {
    getAsset(
      assetId: $assetId
      params: { fields: ["digital_asset.eligible_share_types"] }
    ) {
      id
      enabled
      brand_id
      name
      description

      created_at
      updated_at

      digital_asset {
        id
        created_at
        name

        file_url
        file {
          id
          public_id
          bytes
          width
          height
          resource_type
        }

        eligible_share_types {
          tiktok {
            link
            photo
            video
          }
        }
      }
    }
  }
`
export const CREATE_ASSET_SHARE_MUTATION = gql`
  mutation createAssetShare(
    $resource_id: ID!
    $asset_share: CreateShareAssetShare
  ) {
    createShare(
      shareType: "asset"
      resource_type: "retailers"
      resource_id: $resource_id
      asset_share: $asset_share
    ) {
      id
      status
    }
  }
`
